import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import PosterFormatType from '../../../components/posters/PosterFormatType';
import Progress from './Progress';

export default function Poster({
  imgScrPortrait,
  imgScrLandscape,
  imgAlt,
  formatTypes,
  isLiveEnabled,
  isSerie,
  proveedorName,
  isPlayButtonVisible,
  onClickPlay,
  viewed,
  seenLast,
}) {
  const progress = get(seenLast, 'vistime.last.progress');
  return (
    <div>
      <button className="img-poster" onClick={onClickPlay}>
        <img
          src={imgScrLandscape}
          alt={imgAlt}
          className="hidden-sm hidden-md"
        />
        {isPlayButtonVisible && (
          <span className="play">
            <i className="fa fa-play-circle-o" />
          </span>
        )}
        <img
          src={imgScrPortrait}
          alt={imgAlt}
          className="visible-sm visible-md"
        />
        {isPlayButtonVisible && (
          <span className="play">
            <i className="fa fa-play-circle-o" />
          </span>
        )}
        <PosterFormatType
          item={{
            proveedor_name: proveedorName,
            proveedor_code: proveedorName,
            live_enabled: isLiveEnabled,
            format_types: formatTypes,
          }}
        />
      </button>
      {!isSerie && (
        <Progress
          progressPercentage={progress}
          active={viewed}
          styleContainer={{ height: '4px', marginTop: '12px' }}
        />
      )}
    </div>
  );
}

Poster.defaultProps = {
  progress: 0,
  viewed: false,
  seenLast: 0,
};
Poster.propTypes = {
  seenLast: PropTypes.number,
  progress: PropTypes.number,
  imgScr: PropTypes.string,
  imgAlt: PropTypes.string,
  formatTypes: PropTypes.string,
  proveedorName: PropTypes.string,
  onClickPlay: PropTypes.func,
  isLiveEnabled: PropTypes.bool,
  viewed: PropTypes.bool,
  isSerie: PropTypes.bool,
  isPlayButtonVisible: PropTypes.bool,
};
